import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import {setCookie,getCookie,delCookie} from './common/js/cookie.js'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
//import 'vue-material/dist/theme/default-dark.css' // This line here



import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import routes from './routes'
import Vuelidate from 'vuelidate'
//import 'font-awesome/css/font-awesome.min.css'

Vue.use(VueMaterial)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(Vuelidate)
Vue.prototype.$cookie={setCookie,getCookie,delCookie};

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
//NProgress.start();
if (to.path == '/login') {
    //delCookie('login');
}
let login = getCookie('login');
if (!login && to.path != '/login') {
    next({ path: '/login' })
} else {

    next()
}
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js